module.exports = __webpack_public_path__ + "static/media/ic-choice-decline.76959e00.svg";